import logo from "../../assets/spizop-logo.png";
import maleProfilePic from "../../assets/profile_pic_male.jpeg";
import closeIcon from "../../assets/close_icon.png";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./total_user_count.scss";

interface UserDetails {
  name: string;
  email: string;
  phoneNumber: string;
  activePlans: any;
  registrationDevice: string; // Added registrationDevice
}

const TotalUserCount: React.FC = () => {
  const [role, setRole] = useState<string>("");
  const [employeeDetails, setEmployeeDetails] = useState<any>(null);
  const [users, setUsers] = useState<UserDetails[] | null>(null);
  const [showOverlay, setShowOverlay] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [totalUsers, setTotalUsers] = useState<number>(0);
  const [subscribedUsers, setSubscribedUsers] = useState<number>(0);
  const [notSubscribedUsers, setNotSubscribedUsers] = useState<number>(0);
  const [androidUsers, setAndroidUsers] = useState<number>(0);
  const [iosUsers, setIosUsers] = useState<number>(0);
  const [macUsers, setMacUsers] = useState<number>(0);

  const navigate = useNavigate();
  const isInitialRender = useRef(true);

  const fetchEmployeeDetails = async () => {
    try {
      const email = localStorage.getItem("email");
      const token = localStorage.getItem("token");

      if (!email || !token) {
        navigate("/login");
        return;
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `https://spizopapi.fitoja.in/api/get-employee-details/${email}`,
        config
      );

      setEmployeeDetails(response.data);
      setRole(response.data.role);
      fetchAllUsers();
    } catch (error) {
      handleLogout();
    }
  };

  const fetchAllUsers = async () => {
    try {
      const response = await axios.get(
        "https://spizopapi.fitoja.in/api/get-all-users-info"
      );
      const usersData = response.data.data;

      setUsers(usersData);
      setTotalUsers(usersData.length);

      const subscribedCount = usersData.filter(
        (user: UserDetails) => user.activePlans && user.activePlans.length > 0
      ).length;

      setSubscribedUsers(subscribedCount);
      setNotSubscribedUsers(usersData.length - subscribedCount);

      const androidCount = usersData.filter(
        (user: UserDetails) => user.registrationDevice === "Android"
      ).length;
      setAndroidUsers(androidCount);

      const iosCount = usersData.filter(
        (user: UserDetails) => user.registrationDevice === "iOS"
      ).length;
      setIosUsers(iosCount);

      const macCount = usersData.filter(
        (user: UserDetails) => user.registrationDevice === "Mac"
      ).length;
      setMacUsers(macCount);
    } catch (error) {
      console.error("Failed to fetch fetchAllUsers:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    navigate("/login");
  };

  useEffect(() => {
    if (isInitialRender.current) {
      fetchEmployeeDetails();
      isInitialRender.current = false;
    }
  }, []);

  return (
    <div className="total-user-count-container">
      {loading && (
        <div className="loading-indicator">
          <div className="spinner"></div>
          <p>Loading, please wait...</p>
        </div>
      )}

      {!loading && (
        <>
         {/* Header Section */}
          <header className="dashboard-header">
            <div className="logo" onClick={() => navigate("/dashboard")}>
              <img src={logo} />
            </div>
            <div
              className="profile-section"
              onClick={() => setShowOverlay(!showOverlay)}
            >
              <img className="profile-pic" src={maleProfilePic} alt="Profile" />
            </div>
          </header>

          {/* Overlay for showing user details */}
          {showOverlay && employeeDetails && (
            <div className="profile-overlay">
              <div className="overlay-content">
                <img
                  className="close_icon"
                  onClick={() => setShowOverlay(false)}
                  src={closeIcon}
                />
                <p>
                  <strong>Name:</strong> {employeeDetails.name}
                </p>
                <p>
                  <strong>Email:</strong> {employeeDetails.email}
                </p>
                <p>
                  <strong>Phone Number:</strong> {employeeDetails.phoneNumber}
                </p>
                <p>
                  <strong>Role:</strong> {employeeDetails.role}
                </p>
                <p>
                  <strong>Gender:</strong> {employeeDetails.gender}
                </p>
                <button className="logout-button" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            </div>
          )}

          <main className="content-area">
            <br></br>
            <h1>User Statistics</h1>
            <div className="stats-container">
              <div className="stat-card total-users">
                <span className="stat-value">{totalUsers}</span>
                <span className="stat-label">Total Users</span>
              </div>
              <div className="stat-card subscribed-users">
                <span className="stat-value">{subscribedUsers}</span>
                <span className="stat-label">Subscribed Users</span>
              </div>
              <div className="stat-card non-subscribed-users">
                <span className="stat-value">{notSubscribedUsers}</span>
                <span className="stat-label">Non-Subscribed Users</span>
              </div>
              <div className="stat-card android-users">
                <span className="stat-value">{androidUsers}</span>
                <span className="stat-label">Android Users</span>
              </div>
              <div className="stat-card ios-users">
                <span className="stat-value">{iosUsers}</span>
                <span className="stat-label">iOS Users</span>
              </div>
              <div className="stat-card ios-users">
                <span className="stat-value">{macUsers}</span>
                <span className="stat-label">Mac Users</span>
              </div>
            </div>
          </main>
        </>
      )}
    </div>
  );
};

export default TotalUserCount;